import translations from './translations'

translations.add('en', {
    yourBrowserDoesNotSupportIFrames: 'Your browser does not support iframes.'
})
